import React, { useState, useEffect, Fragment } from "react";
import { Button } from "reactstrap";
import { Wizard, Step, Steps } from "react-albus";
import { FormattedMessage, useIntl } from "react-intl";
import ListerTable from "../Tables/ListerTable";
import { useGetLatest } from "react-table";
import ExpanderCell from "../Tables/ExpanderCell";
import { useService } from "../../context/ServiceContext";

function SeriesAccessoryWizard({ listers, search, onAccessorySelect, accessorySelectText, onSeriesSelect, seriesSelectText, onNoResults }) {
  const intl = useIntl();
  const [history, setHistory] = useState([]);
  const [step, setStep] = useState();

  useEffect(() => {
    loadStep({ step: search.step, filter: search.filter }).then(() => {
      setHistory([{ step: search.step, filter: { ...search.filter } }]);
    });
  }, [search]);

  function getPrefilter() {
    var entry = history[history.length - 1];
    return entry.filter;
  }

  async function loadStep(entry) {
    setStep({ id: entry.step });
    setHistory(history.concat(entry));
  }

  function handleAccessorySelection(value) {
    if (onAccessorySelect) {
      onAccessorySelect(value);
    }
  }

  function handleSeriesSelection(value) {
    if (onSeriesSelect) {
      onSeriesSelect(value);
    }
  }

  function renderSmallTableHeader({ column, children }) {
    return (
      <th {...column.getHeaderProps()} style={{ width: "1%" }}>
        {children}
      </th>
    );
  }

  if (step) {
    let accessoryColumns = [];

    accessoryColumns.push({ Header: intl.formatMessage({ id: "accessories.series", defaultMessage: "Series" }), accessor: "series" });
    accessoryColumns.push({
      Header: intl.formatMessage({ id: "accessories.model", defaultMessage: "Accessory model" }),
      accessor: "name",
    });

    if (onSeriesSelect) {
      accessoryColumns.push({
        id: "seriesa",
        TableHeader: renderSmallTableHeader,
        Cell: ({ cell }) => (
          <Button className="btn btn-outline-danger float-right" onClick={() => handleSeriesSelection(cell.row.original)}>
            {seriesSelectText}
          </Button>
        ),
      });
    }

    accessoryColumns.push({
      id: "select",
      TableHeader: renderSmallTableHeader,
      Cell: ({ cell }) => (
        <Button className="btn btn-outline-danger float-right" onClick={() => handleAccessorySelection(cell.row.original)}>
          {accessorySelectText}
        </Button>
      ),
    });

    return (
      <Wizard>
        <Steps step={step}>
          <Step
            id="accessories"
            render={({ next }) => <ListerTable className={"align-items-center table-flush"} columns={accessoryColumns} lister={listers.accessories} prefilter={getPrefilter()} />}
          />
        </Steps>
      </Wizard>
    );
  } else {
    return <></>;
  }
}

export default SeriesAccessoryWizard;
